import { ReactNode, useRef } from 'react';
import { QueryClient, QueryClientProvider as Provider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

type Props = {
  children: ReactNode;
};

export const QueryClientProvider = ({ children }: Props) => {
  const client = useRef(
    new QueryClient({
      defaultOptions: {
        queries: {
          cacheTime: 1000 * 60 * 60 * 24, // 24h
          refetchOnWindowFocus: false,
        },
      },
    })
  );

  return (
    <Provider client={client.current}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </Provider>
  );
};
